module.exports = __webpack_public_path__ + "static/media/whiteLiveClasses.f9d155b5.svg";